
<div class="mat-typography">
  <div class="wallet-container">
    <div class="back-and-payment-method" *ngIf="paymentMethod">
      <div
        class="selected-payment-method flex justify-center round-border-normal mt-2 sm:mt-4"
      >
        <span
          id="payment-method-img-container"
          class="generic-border-radius"
          [ngClass]="paymentMethod.toLowerCase() !== 'card' ? 'wpx-200 hpx-125 sm:wpx-250 sm:hpx-150 background-cover rounded-md bg-cover flex justify-center items-center mt-4' : 'generic-border-radius'"
        >
          <span
            *ngIf="cardSvgEl && paymentMethod.toLowerCase() === 'card'"
            [innerHTML]="sanitizer.bypassSecurityTrustHtml(cardSvgEl)"
            id-="card_svg_element"
            class="generic-border-radius"
          >
          </span>
          <img
            *ngIf="paymentMethod.toLowerCase() !== 'card'"
            [ngClass]="paymentMethod.toLowerCase() == 'undefined' ? 'w-1/3' : 'w-full'"
            [src]="'../../assets/icons/Payment_Cards/svg/image_' + paymentMethod.toLowerCase() + '_step_three.png'"
          />
        </span>
      </div>
    </div>
    <div
      class="mat-typography flex flex-wrap bg-gray-300 justify-center items-center"
      [ngClass]="mobile ? 'pb-3 pt-3 ml-12 mr-12 mb-8 mt-3' : 'pb-6 pt-6 ml-12 mr-12 mb-16 mt-12'"
      *ngIf="!postbackData"
      style="border-radius: 12px;"
    >
      <p class="text-lg w-100 text-center m-0" *ngIf="loading">
        Getting your transaction details...
      </p>
      <div class="container flex justify-center items-center">
        <mat-spinner
          *ngIf="loading"
          class="loading-spinner mt-2"
          [color]="color"
          [diameter]="diameter"
        >
        </mat-spinner>
      </div>
    </div>
    <div
      class="flex flex-wrap bg-gray-300 justify-center items-center"
      [ngClass]="mobile ? 'pb-3 pt-3 ml-12 mr-12 mb-8 mt-3' : 'pb-6 pt-6 ml-12 mr-12 mb-16 mt-12'"
      *ngIf="postbackData"
      style="border-radius: 12px;"
    >
      <p class="text-xl w-100 text-center m-0" *ngIf="loading">
        Confirming your transaction...
      </p>
      <p
        class="text-xl w-100 text-center m-0"
        *ngIf="!loading && postBackResultSuccessful(postbackData.result) && !userCancelled"
      >
        Transaction Successful
      </p>
      <p class="text-xl w-100 text-center m-0" *ngIf="!loading && postbackData.result === '-1' && !userCancelled">
        Transaction Failed
      </p>
      <p class="text-xl w-100 text-center m-0" *ngIf="!loading && userCancelled">
        Transaction Cancelled
      </p>
      <p class="text-lg w-75 text-center m-0" *ngIf="!loading && postbackData.isShopifyTransaction && postbackData.url == null">
        Your Transaction has been processed, however we were unable to update Shopify with the transaction status.
        We will continue to try and update Shopify in the background! In the meantime you may close this tab.
      </p>
      <div class="w-100 text-center flex justify-center items-center flex-col">
<!--        <p class="text-lg w-75 text-center" *ngIf="!loading && transactionFraud">-->
<!--          Your Mobicred account has been flagged for fraud, please contact-->
<!--          Mobicred to authorize your account-->
<!--        </p>-->
<!--        <p *ngIf="errorMessage" class="p-2 m-0">-->
<!--          {{ errorMessage }}-->
<!--        </p>-->
      </div>
      <div class="container flex justify-center items-center">
        <mat-spinner
          *ngIf="loading"
          class="loading-spinner"
          [color]="color"
          [diameter]="diameter"
        >
        </mat-spinner>
        <div class="flex justify-center items-center flex-col" *ngIf="!loading">
          <img class="wpx-75 mt-1 mb-2" [src]="postBackResultSuccessful(postbackData.result) ? '../../../assets/icons/Icons/icn_success.png' : '../../../assets/icons/Icons/icn_fail.png'" />
<!--          [action]="postbackData.url"-->
          <form novalidate="novalidate" name="post" [action]="postbackData.url" #form id="form"  [method]="postbackData.redirectMethod" [attr.target]="postbackData.redirectFrameTarget || null"  *ngIf="postbackData">
            <input
              *ngFor="let formEle of postbackData.formElements | keyvalue"
              type="hidden"
              [id]="formEle.key"
              [name]="formEle.key"
              [value]="formEle.value"
            />
<!--            <button-->
<!--              mat-raised-button-->
<!--              color="primary"-->
<!--              style="height: fit-content;"-->
<!--              [ngStyle]="{ 'background-color': headerColor }"-->
<!--              (click)="submitForm(form)"-->
<!--            >-->
<!--              Return To Merchant-->
<!--            </button>-->
            <div *ngIf="postbackData && postbackData.url" class="container flex justify-center items-center flex-col">
              <p *ngIf="loadingRedirect" [ngClass]="'text-center'">{{ errorDescription }}</p>
              <mat-spinner
                *ngIf="loadingRedirect"
                class="loading-spinner"
                [color]="color"
                [diameter]="diameterRedirect"
              ></mat-spinner>
            </div>
          </form>
        </div>
      </div>
    </div>

<!--    <div-->
<!--      class="flex flex-wrap bg-gray-300 justify-center items-center"-->
<!--      [ngClass]="mobile ? 'pb-3 pt-3 ml-12 mr-12 mb-8 mt-3' : 'pb-6 pt-6 ml-12 mr-12 mb-16 mt-16'"-->
<!--      *ngIf="postBackFailed"-->
<!--      style="border-radius: 12px;"-->
<!--    >-->
<!--      <p class="text-xl w-100 text-center m-0">-->
<!--        Transaction Failed-->
<!--      </p>-->
<!--      <div class="w-100 text-center flex justify-center items-center flex-col">-->
<!--      </div>-->
<!--      <div class="container flex justify-center items-center">-->
<!--        <img class="wpx-75 mt-3 mb-2" src="../../../assets/icons/Icons/icn_fail.png" />-->
<!--      </div>-->
<!--    </div>-->

    <div
      class="bottom-container w-full flex flex-row items-center pl-0 pr-0 sm:pl-2 sm:pr-2 pb-0 justify-between absolute bottom-0 mat-typography"
    >
      <p class="text-md sm:text-lg ml-2 text-gray-800 mb-0">
        This is a secure transaction
      </p>
      <img
        *ngIf="!hidePgLogo"
        class="sm:h-12 h-10 mr-2 mb-0 sm:mr-2 sm:mb-1"
        src="assets/icons/Icons/Group.png"
      />
    </div>
  </div>
<!--  <div *ngIf="!transactionStatus">-->
<!--    <div class="flex justify-center items-center hpx-450">-->
<!--      <mat-spinner-->
<!--        class="loading-spinner"-->
<!--        [color]="color"-->
<!--        [diameter]="diameter"-->
<!--      ></mat-spinner>-->
<!--    </div>-->
<!--  </div>-->
</div>
